import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const $ = jQuery;

$(function () {
  gsap.config({
    nullTargetWarn: false,
  });

  // animate main opacity
  gsap.to('main', {
    duration: 0.8,
    opacity: 1,
  });

  // hamburger timeline
  const hamburgerTimeline = gsap.timeline({ paused: true });

  // move hamburger lines to the middle
  hamburgerTimeline.to('#hamburger span.first', {
    duration: 0.2,
    y: '10px',
  });
  hamburgerTimeline.to('#hamburger span.third', {
    duration: 0.2,
    delay: -0.2,
    y: '-10px',
  });

  // rotate hamburger
  hamburgerTimeline.to('#hamburger span.first', {
    duration: 0.2,
    rotation: 45,
  });
  hamburgerTimeline.to('#hamburger span.second, #hamburger span.third', {
    duration: 0.2,
    delay: -0.2,
    rotation: -45,
  });

  // menu constants
  const openMenu = gsap.timeline({
    paused: true,
  });
  const openMenuButton = $('#open-menu');
  const openMenuText = $(openMenuButton).find('.text');
  const navItems = $('#nav .col');

  // open menu timeline animations
  openMenu.to('#nav', {
    ease: 'power2.out',
    duration: 0.3,
    autoAlpha: 1,
  });
  openMenu.from(navItems, {
    duration: 0.3,
    stagger: 0.02,
    y: -96,
    opacity: 0,
    delay: -0.3,
  });

  // open menu
  function openMenuActions() {
    hamburgerTimeline.play().timeScale(1);
    openMenu.play().timeScale(1);
    openMenuText.html('sluiten');
    $('html').addClass('no-scroll');
    $('#footer a.hidden').fadeIn(200);
  }

  // close menu
  function closeMenuActions() {
    hamburgerTimeline.reverse().timeScale(-2);
    openMenu.reverse().timeScale(-2);
    openMenuText.html('menu');
    $('html').removeClass('no-scroll');
    $('#footer a.hidden').fadeOut(200);
  }

  // open menu event handler
  openMenuButton.on('click', function () {
    $(this).toggleClass('active');

    if ($(this).hasClass('active')) {
      openMenuActions();
    } else {
      closeMenuActions();
    }
  });

  // modal
  const openModal = gsap.timeline({
    paused: true,
  });

  openModal.to('#modal', {
    ease: 'power2.out',
    duration: 0.3,
    autoAlpha: 1,
  });

  // open modal on button click
  const openModalButtons = $('.open-modal');
  openModalButtons.on('click', function (e) {
    e.preventDefault();
    const modalContent = $(this).data('modal');
    $('#modal .content').hide();
    $('#' + modalContent).show();

    openModal.play().timeScale(1);
    $('html').addClass('no-scroll');

    // play video
    if (modalContent === 'video') {
      $('#modal').css('display', 'flex');
      $('#video-embed').trigger('play');
    }

    // testen maken
    if (modalContent === 'testen-maken') {
      const title = $(this).data('title');
      $('#' + modalContent)
        .find('.modal-title')
        .html(title);

      const text = $(this).data('content');
      $('#' + modalContent)
        .find('.text')
        .html(text);
    }

    // verhaal
    if (modalContent === 'verhaal') {
      const storyId = $(this).attr('id');
      const data = {
        action: 'get_modal_content',
        id: storyId,
      };
      $.post(ajaxurl, data, function (response) {
        $('#story-content').html(response);
      });
    }

    // trainer-coach
    if (modalContent === 'trainer-coach') {
      $('#coach-content').html('');

      const coachId = $(this).attr('id');
      const data = {
        action: 'get_modal_content_coach',
        id: coachId,
      };
      $.post(ajaxurl, data, function (response) {
        $('#coach-content').html(response);
      });
    }
  });

  // close modal
  $('#modal-close').on('click', function () {
    openModal.reverse().timeScale(-2);
    $('html').removeClass('no-scroll');
    $('#video-embed').trigger('pause');
    $('#modal').css('display', '');
  });

  // accordion
  const accordionTitles = $('.accordion .title');
  const accordionGroups = $('.accordion .group');
  const accordionSubtitles = $('.accordion .subtitle');
  const accordionSubitemsGroups = $('.accordion .subitems-group');

  accordionTitles.click(function () {
    const group = $(this).closest('.group');

    // toggle active class
    $('.accordion .title').not(this).removeClass('active');
    $(this).toggleClass('active');

    // hide others
    accordionGroups.not(group).find('.items').slideUp(300);

    // toggle items
    $(group).find('.items').slideToggle(300);

    // hide (possible) subitems
    $('.accordion .subtitle').removeClass('active');
    $('.subitems-group').slideUp(300);
  });

  // accordion with subitems
  accordionSubtitles.click(function () {
    const group = $(this).closest('.subitems').find('.subitems-group');

    // toggle active class
    $('.accordion .subtitle').not(this).removeClass('active');
    $(this).toggleClass('active');

    // hide others
    accordionSubitemsGroups.not(group).slideUp(300);

    // toggle items
    group.slideToggle(300);
    $(this).closest('.subitems').find('.text-field').slideToggle(300);
  });

  // go to step
  const goTo = $('.go-to');
  const dots = $('#dots .dot');
  let disabled = false;

  goTo.click(function () {
    // close menu if opened
    closeMenuActions();
    openMenuButton.removeClass('active');

    // get step data
    const step = $(this).data('step');
    const target = $('#' + step);

    // scroll to (alleen als het doel op deze pagina bestaat)
    if (!target.length) {
      return;
    }
    $('html, body').animate(
      {
        scrollTop: target.offset().top,
      },
      1000
    );

    // enable scroll
    setTimeout(function () {
      disabled = false;
    }, 1000);
  });

  // dot click
  dots.click(function () {
    $(dots).not(this).removeClass('active');
    $(this).addClass('active');
    disabled = true;
  });

  // add class to dot for active (visible) step
  gsap.utils.toArray('.step').forEach(step => {
    ScrollTrigger.create({
      trigger: step,
      start: '-20% top',
      onEnter: () => {
        if (disabled !== true) {
          const stepId = $(step).attr('id');
          dots.removeClass('active');
          $('#dots')
            .find("[data-step='" + stepId + "']")
            .addClass('active');
        }
      },
      onEnterBack: () => {
        if (disabled !== true) {
          const stepId = $(step).attr('id');
          dots.removeClass('active');
          $('#dots')
            .find("[data-step='" + stepId + "']")
            .addClass('active');
        }
      },
    });
  });

  const tooltip = $('.tooltip');
  tooltip.each(function () {
    const tooltipText = $(this).data('tooltip');
    $(this).append('<span>' + tooltipText + '</span>');
  });

  // filter coaches and trainers
  const filterItems = $('#trainer-coach-filter select');
  const trainersCoaches = $('.trainer-coach');

  filterItems.on('change', function () {
    const werkveld = $(this).val();
    trainersCoaches.hide();
    if (!werkveld || werkveld === 'trainer-coach') {
      trainersCoaches.show();
    } else {
      $('.' + werkveld).show();
    }
  });

  // zoeken
  const searchButton = $('#search');
  const searchField = $('#search-field');
  const searchFieldInput = $('#search-input');
  const closeSearch = $('#close-search');

  searchButton.on('click', function () {
    $(searchField).show();
    searchFieldInput.focus();
  });

  closeSearch.on('click', function () {
    $(searchField).hide();
    searchButton.focus();
  });

  // change breadcrumbs home link (alleen in de mijn-scalabor-tak)
  const mijnScalaborBody =
    document.body.classList.contains('single-mijn-scalabor') ||
    document.body.classList.contains('single-trainingen') ||
    document.body.classList.contains('single-workshops') ||
    document.body.classList.contains('single-opleidingen') ||
    document.body.classList.contains('single-arbeidsonderzoeken') ||
    document.body.classList.contains('single-partners');
  const breadcrumbsFirstSpan = $('#breadcrumbs').find('a')[0];
  const mijnScalaborHome = window.location.origin + '/mijn-scalabor/';
  if (mijnScalaborBody && breadcrumbsFirstSpan) {
    $(breadcrumbsFirstSpan).html('Mijn scalabor');
    $(breadcrumbsFirstSpan).attr('href', mijnScalaborHome);
  }
});
